import React from "react";
import Typography from "@mui/material/Typography";

export const Title = ({ title, textVariant = "h6", style = {} }) => {
  return (
    <Typography variant={textVariant} component="div" sx={style}>
      {title}
    </Typography>
  );
};
